import * as L from "leaflet";
import {Marker, Type} from "./Marker";
import {Polyline} from "../util/Polyline";
import {getOrCreatePane, getPaneRenderer, isset, toCenteredLatLng} from "../util/Util";
import {Point} from "../util/Point";

interface PolygonOptions extends L.PolylineOptions {
    key: string;
    polylines: Polyline[];
    pane: string;
}

export class Polygon extends Marker {
    constructor(type: Type) {
        const data: PolygonOptions = type.data as unknown as PolygonOptions;

        let options = {
            ...type.options?.properties,
            smoothFactor: 1.0,
            noClip: false,
            bubblingMouseEvents: true,
            interactive: true,
            attribution: undefined
        };

        if (isset(data.pane)) {
            getOrCreatePane(data.pane);
            options = {
                ...options,
                pane: data.pane,
                renderer: getPaneRenderer(data.pane)
            };
        }

        super(data.key, L.polygon(Polygon.createPoly(data), options));
    }

    public update(raw: unknown[]): void {
        const data: PolygonOptions = raw as unknown as PolygonOptions;
        const polygon: L.Polygon = this.marker as L.Polygon;
        polygon.setLatLngs(Polygon.createPoly(data));
    }

    private static createPoly(data: PolygonOptions): L.LatLng[][] {
        const poly: any[] = [];
        data.polylines.forEach((polyline: Polyline): void => {
            const line: any[] = [];
            polyline.points.forEach((point: Point): void => {
                line.push(toCenteredLatLng(point));
            });
            poly.push(line);
        });
        return poly;
    }
}
